class NotificationTypes {

    constructor() {

        this._PUBLICATION_COMMENT_NEW = "PUBLICATION_COMMENT_NEW";
        this._PUBLICATION_FAVOURITE = "PUBLICATION_FAVOURITE";
        this._PUBLICATION_LIKED = "PUBLICATION_LIKED";
        this._PUBLICATION_COMPLETED = "PUBLICATION_COMPLETED";
        this._PUBLICATION_VIEWED = "PUBLICATION_VIEWED";
        this._COMMENT_LIKED = "COMMENT_LIKED";
        this._COMMENT_MENTION = "COMMENT_MENTION";
        this._GENERIC = "GENERIC";
        this._GENERIC_BROADCAST = "GENERIC_BROADCAST";
        this._IMAGE = "IMAGE";
        this._INTERNAL_LINK = "INTERNAL_LINK";
        this._NEW_CHALLENGE = "NEW_CHALLENGE";
        this._CHALLENGE_FINISHED = "CHALLENGE_FINISHED";
        this._CHAT_NEW_MESSAGE = "CHAT_NEW_MESSAGE";
        this._FOLLOWER_NEW = "FOLLOWER_NEW";
        this._FOLLOWING_COMMENT_LIKED = "FOLLOWING_COMMENT_LIKED";
        this._FOLLOWING_PUBLICATION_NEW = "FOLLOWING_PUBLICATION_NEW";
        this._FOLLOWING_PUBLICATION_LIKED = "FOLLOWING_PUBLICATION_LIKED";
        this._FOLLOWING_PUBLICATION_COMMENT_NEW = "FOLLOWING_PUBLICATION_COMMENT_NEW";
        this._FOLLOWING_PUBLICATION_FAVOURITE = "FOLLOWING_PUBLICATION_FAVOURITE";
        this._TASK = "TASK";
    }

    getNotificationTypes() {

        return {
            PUBLICATION_COMMENT_NEW: this._PUBLICATION_COMMENT_NEW,
            PUBLICATION_FAVOURITE: this._PUBLICATION_FAVOURITE,
            PUBLICATION_LIKED: this._PUBLICATION_LIKED,
            PUBLICATION_COMPLETED: this._PUBLICATION_COMPLETED,
            PUBLICATION_VIEWED: this._PUBLICATION_VIEWED,
            COMMENT_LIKED: this._COMMENT_LIKED,
            COMMENT_MENTION: this._COMMENT_MENTION,
            GENERIC: this._GENERIC,
            GENERIC_BROADCAST: this._GENERIC_BROADCAST,
            IMAGE: this._IMAGE,
            INTERNAL_LINK: this._INTERNAL_LINK,
            NEW_CHALLENGE: this._NEW_CHALLENGE,
            CHALLENGE_FINISHED: this._CHALLENGE_FINISHED,
            CHAT_NEW_MESSAGE: this._CHAT_NEW_MESSAGE,
            FOLLOWER_NEW: this._FOLLOWER_NEW,
            FOLLOWING_COMMENT_LIKED: this._FOLLOWING_COMMENT_LIKED,
            FOLLOWING_PUBLICATION_NEW: this._FOLLOWING_PUBLICATION_NEW,
            FOLLOWING_PUBLICATION_LIKED: this._FOLLOWING_PUBLICATION_LIKED,
            FOLLOWING_PUBLICATION_COMMENT_NEW: this._FOLLOWING_PUBLICATION_COMMENT_NEW,
            FOLLOWING_PUBLICATION_FAVOURITE: this._FOLLOWING_PUBLICATION_FAVOURITE,
            TASK: this._TASK,
        }

    }

}